import Vue from 'vue'

Vue.filter('money-filter', (e) => {
  return '￥' + (e || 0).toFixed(2)
})
